import moment from "moment";

// TODO: Document it
class DateTimeFormatter {

  format(value, format = "DD.MM.YYYY") {
    const date = moment.utc(value);
    return date.format(format);
  }

  isBefore(value, target) {
    const date = moment.utc(value);
    return date.isBefore(moment.utc(target));
  }
}

const instance = new DateTimeFormatter();
export default instance;